<template>
  <div class="contenedor-cpanel">
    <div class="contenedor-titulo">
      <h1>Inscripciones Samyoga 2025</h1>
      <div class="barra"></div>
    </div>
    <section class="contenedor-c">
      <Samyoga2025Lista
      ></Samyoga2025Lista>
    </section>
  </div>
</template>

<script>
import Samyoga2025Lista from '../components/Samyoga2025Lista.vue'
export default {
  name: 'Samyoga2025Estadistica',
  components: {
    Samyoga2025Lista
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>

</style>
